import { render, staticRenderFns } from "./render_interaction.vue?vue&type=template&id=28b90335&scoped=true"
import script from "./render_interaction.vue?vue&type=script&lang=js"
export * from "./render_interaction.vue?vue&type=script&lang=js"
import style0 from "./render_interaction.vue?vue&type=style&index=0&id=28b90335&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b90335",
  null
  
)

export default component.exports